import { render, staticRenderFns } from "./mew-footer.vue?vue&type=template&id=7c270150&scoped=true&"
import script from "./mew-footer.vue?vue&type=script&lang=js&"
export * from "./mew-footer.vue?vue&type=script&lang=js&"
import style0 from "./mew-footer.vue?vue&type=style&index=0&id=7c270150&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c270150",
  null
  
)

component.options.__file = "mew-footer.vue"
export default component.exports